import { useTheme } from "styled-components";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLayout } from "../../../provider/LayoutProvider";
import Button from "../../../components/Button";
import SweetAlert from "sweetalert2";
import services from "../../../services";
import {
  Badget,
  ImageContainer,
  ProfileContainer,
  UserInformationContainer,
} from "./styles";
import { UserDto } from "../../../types/user.dto";
import useIsMobile from "../../../hooks/deviceChecker";

const Component = () => {
  const isMobile = useIsMobile();
  const theme = useTheme() as { [key: string]: { [key: string]: string } };
  const { layout, setLayout } = useLayout();
  const [userInfo, setUserInfo] = useState<UserDto>();

  useEffect(() => {
    setLayout({
      ...layout,
      showSubHeader: false,
      fullFillContent: true,
      showSearchBar: false,
      showFilters: false,
      showTitle: false,
      showBreadcrumb: false,
      showActions: false,
    });
    setUserInfo(services.user.getUserInformation());
  }, []);

  return (
    <ProfileContainer>
      <ImageContainer imageUrl={null} />
      <UserInformationContainer>
        <b>
          {userInfo?.nombre?.charAt(0).toUpperCase()}
          {userInfo?.nombre?.slice(1)}{" "}
          {userInfo?.apellido?.charAt(0).toUpperCase()}
          {userInfo?.apellido?.slice(1)}
        </b>
        <Badget>MCA</Badget>
      </UserInformationContainer>
      <Button
        style={{ width: "100%" }}
        options={{
          type: "link",
          size: "sm",
          skin: "primary",
        }}
        onClick={() => {
          SweetAlert.fire({
            title: "Cerrar Sesión",
            text: "¿Estás seguro que quieres salír?",
            showCancelButton: false,
            confirmButtonText: "Confirmar",
            allowEscapeKey: false,
            position: "center",
            width: isMobile ? "90%" : "50%",
            confirmButtonColor: theme.colors.Primary,
            preConfirm: () => {
              services.auth.signOut(process.env.REACT_APP_MCA_URL);
            },
          });
        }}
      >
        Cerrar sesión
      </Button>
    </ProfileContainer>
  );
};

const states = ({ userStore }) => {
  const { data: user } = userStore.information;

  return {
    user,
  };
};

export default connect(states)(Component);
